import React from 'react';
import { SwitchContainer, Switch } from './styles.js';

const defaultIsDisabled = () => false;

const SwitchTabs = props => {
  const { items, width, activeTab, setActiveTab, isDisabled = defaultIsDisabled } = props;
  return (
    <SwitchContainer width={width}>
      {items.map((item, index) => (
        <Switch width={width} tabsCount={items?.length} activeTab={activeTab} key={index} disabled={isDisabled(index)}>
          <input
            name="switch"
            id={item + index}
            type="radio"
            checked={index === activeTab}
            onChange={() => setActiveTab(index)}
            disabled={isDisabled(index)}
          />
          <label htmlFor={item + index}>{item}</label>
          <div className="switch__indicator" />
        </Switch>
      ))}
    </SwitchContainer>
  );
};

export default SwitchTabs;
